import { render } from "./StudentPlaceFlashQuestion.vue?vue&type=template&id=389ecc65"
import script from "./StudentPlaceFlashQuestion.vue?vue&type=script&lang=js"
export * from "./StudentPlaceFlashQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__